import styled from 'styled-components';

export const Legend = styled.p`
  width: 80%;
  text-align: center;
`;
